<template>
  <el-date-picker
    format="YYYY/MM/DD HH:mm"
    value-format="YYYY-MM-DD HH:mm:ss"
    range-separator="-"
    :start-placeholder="
      $t(props.config?.startPlaceholder ?? 'common.startDate')
    "
    :end-placeholder="$t(props.config?.endPlaceholder ?? 'common.endDate')"
    v-bind="$attrs"
    clearable
  />
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "form-date",
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  emits: ["change"],
  setup(props) {
    const { t } = useI18n();
    return {
      t,
      props
    };
  }
});
</script>
